import PropTypes from 'prop-types';
import React from 'react';
import ReportParameters from '../report/ReportParameters';

class ReportParametersWrapper extends React.Component {

  render() {

    const { savedQuery, project, graph, existingComponents, data, projectType, projectUsers,
      onUpdateQueryParameters, onClear, runQuery, queryRunning, entitlements, query } = this.props;

    return (
      <ReportParameters
        project={project}
        id={savedQuery}
        graph={graph}
        entitlements={entitlements}
        existingComponents={existingComponents}
        defaultLang={data.defaultLang}
        query={query}
        queryRunning={queryRunning}
        margin={true}
        onUpdateQueryParameters={onUpdateQueryParameters}
        onClear={onClear}
        runQuery={runQuery}
        projectType={projectType}
        projectUsers={projectUsers}
      />
    );
  }
}

ReportParametersWrapper.propTypes = {
  savedQuery: PropTypes.string.isRequired
};

export default ReportParametersWrapper;
